import { nfcCardBlacklistsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("nfc-card-blacklist"),
  endpoint: "nfc-card-blacklists",
  operations: nfcCardBlacklistsOps,
  roleView: [ROLE.REGION_CODE_VIEW, ROLE.REGION_CODE_ADMIN],
  roleAdmin: [ROLE.REGION_CODE_ADMIN],
  singularName: (t) => t("Digi blacklist"),
  name: (t) => t("Digi blacklist"),
  syncCustomerFilter: true,
  dependencies: ["nfc-card"],
});

export default conf;
